import api from '../authService/authService';

// Workspace service functions
export const getAllWorkspaces = async (params?: {
  isAdmin?: boolean;
  archive?: boolean;
}) => {
  try {
    const response = await api.get('workspace/all', {
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching workspaces:', error);
    throw error;
  }
};

export const archiveWorkspace = async (workspaceId: string) => {
  try {
    const response = await api.patch(`workspace/archive/${workspaceId}`);
    return response.data;
  } catch (error) {
    console.error('Error archiving workspace:', error);
    throw error;
  }
};

export const getWorkspaceById = async () => {
  try {
    const response = await api.get(`workspace/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching workspace:', error);
    throw error;
  }
};

export const createWorkspace = async (workspaceData: { name: string }) => {
  try {
    const response = await api.post('workspace', workspaceData);
    return response.data;
  } catch (error) {
    console.error('Error creating workspace:', error);
    throw error;
  }
};

export const updateWorkspace = async (workspaceData: { name: string }) => {
  try {
    const response = await api.patch('workspace/update', workspaceData);
    return response.data;
  } catch (error) {
    console.error('Error updating workspace:', error);
    throw error;
  }
};

export const deleteWorkspace = async (workspaceId: string) => {
  try {
    const response = await api.delete(`workspace/${workspaceId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting workspace:', error);
    throw error;
  }
};

export const switchWorkspace = async (workspaceId: string) => {
  try {
    const response = await api.post('auth/switch-workspace', {
      workspaceId: workspaceId,
    });
    return response.data;
  } catch (error) {
    console.error('Error switching workspace:', error);
    throw error;
  }
};

export const removeUserFromWorkspace = async (userId: string) => {
  try {
    const response = await api.delete(`workspace/remove/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error removing user from workspace:', error);
    throw error;
  }
};

export const updateWorkspaceSettings = async (data: {
  duplicateEmailEnabled: boolean;
  mergeOption?: 'oldest' | 'newest';
}) => {
  try {
    const apiData: {
      duplicateEmailEnabled: boolean;
      mergeType?: 'oldest' | 'newest';
    } = {
      duplicateEmailEnabled: data.duplicateEmailEnabled,
    };

    if (data.mergeOption) {
      apiData.mergeType = data.mergeOption;
    }

    const response = await api.put('/workspace/update/settings', apiData);
    return response.data;
  } catch (error) {
    console.error('Error updating workspace settings:', error);
    throw error;
  }
};
